import { ButtonColor } from "@/common/enum/button-color";
import { Button, Modal } from "flowbite-react";
import React from "react";
import { GrayExclamationCircleIcon } from "../icon/GrayExclamationCircleIcon";
import { Body16Regular } from "../typography/Body16Regular";

interface Props {
  handleSubmit: () => void;
  closeModal: () => void;
}

export const CreateItemModal: React.FC<Props> = ({
  handleSubmit,
  closeModal,
}) => {
  return (
    <Modal size="md" show={true} onClose={closeModal}>
      <Modal.Header className="pt-[10px] px-[10px] h-[36px] border-none"></Modal.Header>
      <Modal.Body className="p-0">
        <div className="flex flex-col items-center box-border py-[20px] gap-[20px]">
          <div className="w-[42px] h-[42px] flex items-center justify-center">
            <GrayExclamationCircleIcon size={35} />
          </div>
          <div className="flex flex-col items-center">
            <Body16Regular className="text-semantic-text-secondary">
              상품을 등록하시겠어요?
            </Body16Regular>
            <Body16Regular className="text-semantic-text-secondary">
              등록 후 판매가 설정이 필요합니다.
            </Body16Regular>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="pt-0 border-none">
        <div className="flex gap-[16px] items-center justify-center w-full">
          <Button
            size="sm"
            color={ButtonColor.TRANSPARENT_OUTLINE}
            onClick={closeModal}
          >
            취소하기
          </Button>
          <Button size="sm" color={ButtonColor.PRIMARY} onClick={handleSubmit}>
            등록하기
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
